export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/loading_state_incomplete-c48b675cfe8c72ed405d7ec2dcc84de5.svg";